"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchWrapper = exports.SearchInput = exports.SearchIcon = exports.InteractionIcons = exports.Input = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreIconButton = require("@legacy-vfuk/core-icon-button");

var _coreTextInput = require("@legacy-vfuk/core-text-input");

var _coreAnimate = require("@legacy-vfuk/core-animate");

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SearchWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearchTextInputstyle__SearchWrapper",
  componentId: "sc-6ru1tt-0"
})(function () {
  return (0, _styledComponents.css)(["display:flex;"]);
});

exports.SearchWrapper = SearchWrapper;

var Input = _styledComponents["default"].span.withConfig({
  displayName: "SearchTextInputstyle__Input",
  componentId: "sc-6ru1tt-1"
})(function () {
  return (0, _styledComponents.css)(["", "{border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;", ";}"], _coreTextInput.TextInputStyles.TextInput, (0, _coreMixins.spacing)('padding-left', 3));
});

exports.Input = Input;

var SearchInput = _styledComponents["default"].div.withConfig({
  displayName: "SearchTextInputstyle__SearchInput",
  componentId: "sc-6ru1tt-2"
})(function () {
  return (0, _styledComponents.css)(["position:relative;align-items:center;flex-grow:1;"]);
});

exports.SearchInput = SearchInput;

var InteractionIcons = _styledComponents["default"].div.withConfig({
  displayName: "SearchTextInputstyle__InteractionIcons",
  componentId: "sc-6ru1tt-3"
})(function () {
  return (0, _styledComponents.css)(["", "{display:flex;align-items:center;}", ";position:absolute;display:flex;align-items:center;top:0;bottom:0;right:0;"], _coreAnimate.AnimateStyles.Animate, (0, _coreMixins.spacing)('padding-right', 3));
});

exports.InteractionIcons = InteractionIcons;

var SearchIcon = _styledComponents["default"].span.withConfig({
  displayName: "SearchTextInputstyle__SearchIcon",
  componentId: "sc-6ru1tt-4"
})(function (props) {
  var localTheme = (0, _coreIconButton.iconButtonTheme)(props.theme);
  var borderSize = props.hasState ? 4 : 2;
  var mobileBorderSize = props.hasState ? 2 : 0;
  return (0, _styledComponents.css)(["", "{border-top-left-radius:0;border-bottom-left-radius:0;height:", "px;", "}"], _coreIconButton.IconButtonStyles.IconButton, mobileBorderSize + localTheme.size[props.size].sm.buttonSize, _coreMixins.respondTo.md((0, _styledComponents.css)(["height:", "px;"], borderSize + localTheme.size[props.size].md.buttonSize)));
});

exports.SearchIcon = SearchIcon;
//# sourceMappingURL=SearchTextInput.style.js.map